export default __webpack_public_path__ + "static/media/SetDateRangeConsumption.00082068.png";